import { reportBi } from '../../../essentials';
import { getEditorSubType } from '../../../utils';
import type { IntentInstallStore } from './IntentInstallStore';

export const enum IntentInstallBIEvent {
  INTENT_INSTALL_BEGIN = 156,
}
export const enum IntentInstallBIEventStep {
  CHECK_INSTALL = 'CHECK_INSTALL',
  BEGIN_INSTALL = 'BEGIN_INSTALL',
}

export class BIManager {
  constructor(private intentInstallStore: IntentInstallStore) {}

  public reportIntentInstallBegin(step: IntentInstallBIEventStep) {
    return reportBi(IntentInstallBIEvent.INTENT_INSTALL_BEGIN, {
      installationId: this.intentInstallStore.getInstallationId(),
      appDefinitionId: this.intentInstallStore.getAppsToInstall(),
      origin: this.intentInstallStore.getOriginType(),
      editorType: getEditorSubType(),
      step,
    });
  }
}
